import { apiClient } from '@core/api/ApiClientFactory';
import type { ApkListResponse } from './types';
import { FastLanerTrolleyData } from '@/services/dashboardService.ts';

export const fastLanerService = {
    async loadApkList(groupId: string, config?: any): Promise<ApkListResponse> {
        try {
            const response = await apiClient.get<ApkListResponse>(`fastlaner/apk-list/${groupId}`, config);
            return response.data;
        } catch (error) {
            console.error('[FastLanerService] Error loading apk list:', error);
            throw error;
        }
    },

    async uploadFastlanerApk(groupId: string, formData: FormData): Promise<void> {
        try {
            await apiClient.post(`fastlaner/apk-upload/${groupId}`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            return;
        } catch (error) {
            console.error('[FastLanerService] Error uploading fastlaner apk:', error);
            throw error;
        }
    },

    async activateFastlanerApk(params: string): Promise<void> {
        try {
            await apiClient.get(`fastlaner/apk-activate?${params}`);
            return;
        } catch (error) {
            console.error('[FastLanerService] Error activating fastlaner apk:', error);
            throw error;
        }
    },

    async getTrolleyData(groupIds: string[]): Promise<FastLanerTrolleyData> {
        try {
            const params = groupIds.map((id) => `groupId=${encodeURIComponent(id)}`).join('&');
            const response = await apiClient.get<FastLanerTrolleyData>(`fastlaner/trolley-data?${params}`);
            return response.data;
        } catch (error) {
            console.error('[FastLanerService] Error getting trolley data:', error);
            throw error;
        }
    }
};
